<script>
  import { _ as t } from "svelte-i18n";
  import { query } from "svelte-apollo";

  import { client } from "apollo.js";
  import { ME_CLIENT_LAWCASE_QUERY } from "./queries.js";
  import { analyticTrack } from "utils.js";

  import Content from "./Content.svelte";

  const lawcases = query(client, {
    query: ME_CLIENT_LAWCASE_QUERY,
  });

  analyticTrack();
</script>

{#await $lawcases}
  <p>{$t("loading")}</p>
{:then result}
  <div class="welcome">
    {@html $t("welcome.welcome", {
      values: { name: result.data.meClient.name },
    })}
  </div>
  <Content
    lawcases={result.data.meClient.lawcases}
    client={result.data.meClient}
  />
{:catch error}
  <p>ERROR: {error}</p>
{/await}

<style>
  .welcome {
    padding: 48px 0;
    font-size: 32px;
    line-height: 48px;
  }
</style>
